// stringUtils.ts
export const CapitalizeFirstLetter = (sentence: string): string => {
  if (!sentence) return sentence; // Handle empty strings
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
};

export const capitalizeAllLetter = (sentence: string): string => {
  // console.log("Sentenc:", sentence);
  if (typeof sentence !== "string") {
    // console.log("Input is not a string:", sentence);
    return sentence; // Or handle it differently, e.g., return the input as is
  }
  return sentence
    .split(/[\s_-]+/) // Split by spaces or underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" "); // Join back with spaces
};
